import { ChangeDetectionStrategy, Component, effect } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { OiqFormCheckboxComponent } from '@oiq-ui-sdk/form';
import { CollectionTableFilterBaseComponent } from './filter.component';
import { CollectionFilterDefinition } from './filter.models';
import {
  CollectionFilterFormatPayloadCheckbox,
  CollectionFilterFromQueryCheckbox,
} from './filter.utils';
@Component({
  selector: 'collection-filter-checkbox',
  standalone: true,
  imports: [ReactiveFormsModule, OiqFormCheckboxComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @let _definition = definition();
    @if (_definition) {
      <!-- Use OiqFormPhoneComponent for phone (has built-in mask) -->
      <oiq-form-checkbox
        [label]="_definition.checkbox?.label || _definition.label || _definition.placeholder"
        [type]="_definition.checkbox.type || 'toggle'"
        [formControl]="internalControl"
        (event)="onValueChange($event)">
      </oiq-form-checkbox>
    }
  `,
})
export class CollectionFilterCheckboxComponent extends CollectionTableFilterBaseComponent {
  internalControl = new FormControl('');

  constructor() {
    super();
    effect(() => {
      const _value = this.value();
      const _definition = this.definition();
      if (!_definition) {
        return;
      }
      const _normalized = CollectionFilterFromQueryCheckbox(_value, _definition, false);
      if (this.internalControl.value === _normalized) {
        return;
      }
      this.internalControl.setValue(_normalized || null, {
        emitEvent: false,
      });
    });
  }

  getQuery() {
    return CollectionFilterFormatPayloadCheckbox(this.internalControl.value, this.definition());
  }

  onValueChange(value: { type: string; data?: any }): void {
    switch (value.type) {
      case 'change':
        this.handleValueChanged();
    }
  }

  static fromQuery(query: any, definition: CollectionFilterDefinition): { [key: string]: any } {
    return CollectionFilterFromQueryCheckbox(query, definition, true);
  }
}
